module.exports = __webpack_public_path__ + "img/dksteel.0b86575e.png";